module.exports = __webpack_public_path__ + "img/empty-notifications@2x.37220d05.png";